import React from 'react';
import s from './ImprovementPlan.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Table from 'react-bootstrap/Table';
import ascendingIcon from '../../../assets/arrow-up.png';
import descendingIcon from '../../../assets/arrow-down.png';
import Button from 'react-bootstrap/Button';
import { getDateInDDMMYYYFormat } from '../../../utils/index';
import { useSelector } from 'react-redux';
import { getCurrentTimezone } from '../../../selectors/index';

const ImprovementPlanListTable = ({
  paginatedData,
  onSortOrder,
  asendingOrder,
  viewImprovementPlan,
  viewAllowed,
  deleteAllowed,
  removeImprovementPlan
}) => {
  let sortIcon = asendingOrder ? ascendingIcon : descendingIcon;
  const currentTimezone = useSelector(state => getCurrentTimezone(state));

  return (
    <div className="">
      <Table variant className={s.table}>
        <thead>
          <tr>
            <th>
              <FormattedMessage id="common.name" defaultMessage="Name" />
            </th>
            <th className={s.sortHeading}>
              <span onClick={onSortOrder}>
                <FormattedMessage id="improvementPlan.dateRaised" defaultMessage="Date Raised" />
                <img className={s.sortIcon} src={sortIcon} alt="icon" />{' '}
              </span>
            </th>
            <th>
              <FormattedMessage id="improvementPlan.dateDue" defaultMessage="Date Due" />
            </th>
            <th>
              <FormattedMessage id="common.status" defaultMessage="Status" />
            </th>
            {(viewAllowed || deleteAllowed) && <th></th>}
          </tr>
        </thead>
        <tbody>
          {paginatedData.map(n => {
            return (
              <tr key={n.ImprovementPlanId}>
                <td>{n.Name || ''}</td>
                <td>{getDateInDDMMYYYFormat(n.DateRaised, currentTimezone) || ''}</td>
                <td>{getDateInDDMMYYYFormat(n.DateDue, currentTimezone) || ''}</td>
                <td>{n.Status || ''}</td>

                <td className={s.btnCol}>
                  {viewAllowed && (
                    <Button
                      variant="outline-secondary"
                      className={s.viewButton}
                      href="#"
                      onClick={() => {
                        viewImprovementPlan(n.ImprovementPlanId);
                      }}
                      data-unittest="viewData"
                    >
                      <FormattedMessage id="common.view" defaultMessage="VIEW" />
                    </Button>
                  )}
                  {deleteAllowed && (
                    <Button
                      variant="outline-secondary"
                      className={s.removeButton}
                      href="#"
                      onClick={() => {
                        removeImprovementPlan(n.ImprovementPlanId);
                      }}
                      data-unittest="removeData"
                    >
                      <FormattedMessage id="common.remove" defaultMessage="REMOVE" />
                    </Button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

ImprovementPlanListTable.defaultProps = {
  paginatedData: [],
  currentPage: 1
};

export default injectIntl(ImprovementPlanListTable);
